import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/landing';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-brand-soft px-5 py-16 md:py-24" data-id="element-95" data-mp="1223hh69aexzq">
      <div className="mx-auto max-w-3xl" data-id="element-96" data-mp="124pp15w6hdhy">
        <SectionHeading title="Lo que más nos preguntan" data-id="element-97" data-mp="1pro4q1ch4het" />
        <ul className="mt-12 space-y-3" data-id="element-98" data-mp="1puajakxs7x6j">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.question} className="overflow-hidden rounded-2xl bg-white shadow-sm" data-id="element-99" data-mp="1g2e94bif8gly" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-base font-bold text-brand transition-colors duration-150 ease-out hover:text-brand-strong focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand md:text-lg" data-id="element-100" data-mp="1l1hgw3psd0xm">
                  {f.question}
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-101" data-mp="2js72jjidnfr9">
                    <PlusIcon className="h-4 w-4 text-brand" strokeWidth={3} aria-hidden="true" data-id="element-102" data-mp="2tos6s2mkomu1" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-103" data-mp="37evoqhef5udo">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-104" data-mp="32ieynhnnt5xy">
                      <p className="px-6 pb-6 text-base leading-relaxed text-charcoal" data-id="element-105" data-mp="1i2jzd7qg1czk">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}